import { setUserPrefs, updateUserPref } from "../helpers/backend_helper";
import { avatarImages } from "./items";

export function getConfigColumnFromList(userStored, listId, tableHead) {
    const userPref = (typeof userStored.prefs == 'string') ? JSON.parse(userStored.prefs) : userStored.prefs;
    
    // Configuration par défaut : toutes les colonnes visibles
    const defaultConfig = tableHead.reduce((config, column) => {
        config[column.key] = true;
        return config;
    }, {});

    // Si pas de préférences utilisateur, retourner la config par défaut
    if (!userPref || !userPref?.lists) {
        return defaultConfig;
    }

    // Chercher la liste correspondante
    let list = userPref?.lists?.find((a) => a.id === listId);
    
    // Si la liste n'existe pas, retourner la config par défaut
    if (!list) {
        return defaultConfig;
    }

    // NOUVELLE LOGIQUE : Si l'autosave n'est pas activé, afficher toutes les colonnes
    if (!list.autoSave) {
        return defaultConfig;
    }

    // Si l'autosave est activé, utiliser la configuration sauvegardée
    return list.cols || defaultConfig;
}

export function getAutoSavePrefFromList(userStored, listId) {
    const userPref = (typeof userStored.prefs == 'string') ? JSON.parse(userStored.prefs) : userStored.prefs;
    
    if(userPref && userPref?.lists){
        let list = userPref?.lists?.find((a) => {return a.id == listId});
        if(list && list.hasOwnProperty('autoSave')){
            return list.autoSave;
        }
    }
    return false; // Valeur par défaut
}

export function setConfigColumnFromList(user, listId, newCols, filters, savePref) {
    let userPref = (typeof user.prefs == 'string') ? JSON.parse(user.prefs) : user.prefs;
    
    // Create a new object for userPref to avoid mutation
    let updatedPref = { ...userPref };
    
    if(!updatedPref.lists) {
        updatedPref.lists = [];
    }
    
    // Find existing list
    let listStored = updatedPref.lists.find((a) => a.id === listId);
    
    // Filter out the existing list if present
    let listOld = updatedPref.lists.filter((a) => a.id !== listId);
    
    if(!listStored) {
        listStored = {id: listId};
    }
    
    // Create a new object for the list to avoid mutation
    let updatedList = { 
        ...listStored, 
        cols: newCols, 
        filters: filters,
        autoSave: savePref // Toujours sauvegarder l'état du switch
    };
    
    // Create a new array instead of mutating the existing one
    updatedPref.lists = [...listOld, updatedList];
    
    // MODIFICATION: Toujours retourner les préférences mises à jour
    // pour permettre la sauvegarde de l'état du switch
    return updatedPref;
}

export function setAutoSavePrefForList(user, listId, autoSaveState) {
    let userPref = (typeof user.prefs == 'string') ? JSON.parse(user.prefs) : user.prefs;
    
    let updatedPref = { ...userPref };
    
    if(!updatedPref.lists) {
        updatedPref.lists = [];
    }
    
    // Find existing list
    let listStored = updatedPref.lists.find((a) => a.id === listId);
    let listOld = updatedPref.lists.filter((a) => a.id !== listId);
    
    if(!listStored) {
        listStored = {id: listId, cols: {}, filters: []};
    }
    
    // Update only the autoSave state
    let updatedList = { 
        ...listStored, 
        autoSave: autoSaveState
    };
    
    updatedPref.lists = [...listOld, updatedList];
    
    return updatedPref;
}

export function updateUserPrefs(key, value, user) {
    if (!user.prefs) {
      user.prefs = {};
    }
  
    user.prefs[key] = value;
    //localStorage.setItem('user', JSON.stringify(user));
  
    // Assuming setUserPrefs is available in the current scope
    setUserPrefs(user);
}

export function getUserPrefs(user) {
    return user && user.prefs ? user.prefs : {};
};

export function hasUserBanRight(user) {
  return user && user.rights && user.rights.includes('user_ban');
};

export function hasRight(key, right, user) {
  return user && user.rights && user.rights.includes(key+'_'+right);
};

export function hasAllRights(rights2, user) {
  const rights1 = user.rights;
  if (!rights1 || !rights2) {
    return false;
  }


  return rights2.every(right => rights1.includes(right)) && rights1.length >= rights2.length;
} 

export function hasOneRight(key, rights, user) {
  const hasOneRight = user && user.rights && rights.some((el) => 
    user.rights.includes(key+'_'+el)
  )
  return hasOneRight;
};

export function getProfileImage (userPref, defaultImg) {
  if(userPref) {
    let pref = userPref;
    if (typeof pref === 'string') { // Check if it's a string and parse it
      pref = JSON.parse(pref);
    }

    if (pref.profileImage == null) {
      return defaultImg; // Return default image if profileImage is null
    }
    
    return avatarImages.find((image) => image.id == pref.profileImage).path; // search image by id
  }
  return defaultImg;
}